module.exports = __webpack_public_path__ + "static/media/ipiranga-loading.63a1c958.gif";